import { ScreenOrientation } from '@capacitor/screen-orientation';
import { defineBoot } from '@quasar/app-vite/wrappers';
import store from 'src/store';

/**
 * @param {{ app: import('vue').App }} params
 */
export default defineBoot(({ app }) => {
  window.addEventListener('resize', () => {
    app.config.globalProperties.$q.screen.mobileHeight = window.innerHeight < 400;
  });
  window.dispatchEvent(new Event('resize'));

  ScreenOrientation.addListener('screenOrientationChange', (screenOrientation) => {
    // Set the orientation
    store().dispatch('app/setOrientation', screenOrientation);
  });
});
